<template>
  <LmDialog v-model="modalShow" :styles="dialogStyles" title="Create stakeholder">
    <template #toolbar-actions>
      <q-btn label="Save" color="tertiary" size="sm" @click="submit" />
    </template>
    <template #content>
      <q-card-section>
        <form @submit.prevent="submit()">
          <div class="row q-col-gutter-md q-mb-md">
            <div class="col">
              <q-input id="first_name" v-model="formData.first_name" type="text" label="First Name" outlined />
            </div>

            <div class="col">
              <q-input id="last_name" v-model="formData.last_name" type="text" label="Last Name" outlined />
            </div>

            <div class="col">
              <q-input id="email" v-model="formData.email" type="email" label="Email" outlined />
            </div>
          </div>
          <div class="row q-col-gutter-md">
            <div class="col">
              <q-input id="phone" v-model="formData.phone" type="text" label="Phone" outlined />
            </div>

            <div class="col">
              <q-input id="job" v-model="formData.job" type="text" label="Job" outlined />
            </div>

            <div class="col">
              <q-select
                id="department"
                v-model="formData.departments"
                :options="departments"
                multiple
                emit-value
                map-options
                option-value="id"
                option-label="name"
                label="Departments"
                outlined
              />
            </div>
          </div>
        </form>
      </q-card-section>
    </template>
  </LmDialog>
</template>

<script>
import { LmFormObject } from '@/lib/models/lm-form-object.class'
import { cloneDeep } from 'lodash'
// Components
import LmDialog from '@/reusable/base-components/LmDialog/LmDialog'
export default {
  components: { LmDialog },
  props: {
    showing: {
      type: Boolean
    },
    departments: Array
  },

  data() {
    return {
      namespace: 'stakeholders',
      stakeholderCreated: false,
      formData: new LmFormObject({
        first_name: null,
        last_name: null,
        email: null,
        phone: null,
        job: null,
        departments: []
      }),
      dialogStyles: { minWidth: '900px', minHeight: '200px' }
    }
  },

  computed: {
    modalShow: {
      get() {
        return this.showing
      },
      set(val) {
        !val && this.closeModal()
      }
    }
  },

  methods: {
    prepareFormData() {
      let data = cloneDeep(this.formData)
      delete data.errors
      delete data.originalData
      return data
    },
    submit() {
      let formData = this.prepareFormData()
      this.stakeholderCreated = true
      let params = {
        namespace: `stakeholders`,
        value: formData
      }
      return this.$store.dispatch(`data/create`, params).then(result => {
        this.$emit('refresh', result)
        this.closeModal()
      })
    },
    closeModal() {
      this.$emit('close')
      this.stakeholderCreated = false
      this.$set(this, 'formData', new LmFormObject(this.formData.originalData))
    }
  }
}
</script>
